import React from 'react';
import styled from 'styled-components';

import { FilestackImageData } from 'api/shared';
import Box from 'components/Box';
import Hero from 'components/Hero';
import SearchToolbar from 'components/SearchToolbar';
import { H1, RichText } from 'components/Text';
import HideContainer from 'containers/HideContainer';
import PostSearchInputContainer from 'containers/PostSearchInputContainer';
import ScrollWatcherContainer from 'containers/ScrollWatcherContainer';

import {
  breakpoints,
  colors,
  fontSizesByType,
  gutterWidth,
  maxWidth,
  shadows,
  transition,
} from '../theme';

const Title = styled.div<{ lineHeight?: number }>`
  font-size: ${fontSizesByType.h3[0]}px;
  @media (min-width: ${breakpoints[1]}) {
    font-size: ${fontSizesByType.h3[2]}px;
  }
`;
const FixedMenu = styled.div.attrs<{ isFullyAboveViewport?: boolean }>(
  ({ isFullyAboveViewport }) => ({
    style: {
      transform: isFullyAboveViewport
        ? 'translateY(0)'
        : 'translateY(-100%) translateY(-4px)',
    },
  })
)`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  box-shadow: ${shadows.toolbar};
  transition: all ${transition};
  will-change: transform;
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const ArticleSearchHero = ({
  content,
  subsite,
  title,
  image,
  imageMobile,
  parallax,
  showListingCounts,
  searchMode,
}: {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  content: Record<string, any>;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  subsite: Record<string, any>;
  title?: string;
  image: FilestackImageData | null | undefined;
  imageMobile: FilestackImageData | null | undefined;
  parallax?: boolean;
  showListingCounts?: boolean;
  searchMode?: boolean;
}) => (
  <>
    <Hero
      pb={[48, null, null, 64]}
      pt={[48, null, null, 80]}
      mb={[120, null, null, 0]}
      minHeight="calc(100vh - 300px)"
      heroImage={image}
      mobileHeroImage={imageMobile}
      data-qa-id="search-hero"
      parallax={parallax}
      alwaysShow
    >
      {!searchMode && (
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
          <Box
            transform={[
              'translateY(180px) translateZ(0)',
              null,
              null,
              'translateZ(0)',
            ]}
            width="100%"
            maxWidth={[400, null, null, maxWidth[3]]}
            px={[0, null, null, gutterWidth]}
            m="0 auto"
          >
            <Box
              width={[1, null, null, 1 / 2]}
              px={[20, null, null, 60]}
              py={[20, null, null, 40]}
              borderRadius={12}
              boxShadow="0 0 6px rgba(0,0,0,0.3)"
              bg="white"
              color={colors.greyishBrown}
            >
              <RichText mb={24}>
                <H1>
                  <Title
                    lineHeight={1.3}
                    dangerouslySetInnerHTML={{
                      __html:
                        title && title.replace(/<(\/?)(p|h1)>/g, '<$1span>'),
                    }}
                  />
                </H1>
              </RichText>
              <Box data-qa-id="article-search-hero-menu">
                <PostSearchInputContainer
                  isStatic
                  homePageUrl={subsite ? subsite.homePage.url : ''}
                  searchPlaceholderText={
                    subsite && subsite.searchPlaceholderText
                      ? subsite.searchPlaceholderText
                      : undefined
                  }
                />
              </Box>
            </Box>
          </Box>
        </>
      )}
      {/* {cta} */}
    </Hero>
    <ScrollWatcherContainer
      offset={[64, 64, 64, 96 + (showListingCounts ? 80 : 0)]}
    >
      {({ isFullyAboveViewport }) => (
        <HideContainer xs sm md>
          <Box data-qa-id="article-search-hero-menu">
            {/* @ts-expect-error Fix type */}
            <FixedMenu isFullyAboveViewport={isFullyAboveViewport}>
              {/* @ts-expect-error ts-migrate(2322) FIXME: Type 'Record<string, any>' is not assignable to ty... Remove this comment to see the full error message */}
              <SearchToolbar content={content} subsite={subsite} />
            </FixedMenu>
          </Box>
        </HideContainer>
      )}
    </ScrollWatcherContainer>
  </>
);

export default ArticleSearchHero;
